import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComponent, GridPaginationButtonsComponent, GridSkeletonComponent, GridV2Component } from './components';
import { GridViewBuilderService } from './services';
import { DataFilterModule } from '@anecdotes/design-system/data-manipulation';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { MultiselectModule } from '@anecdotes/design-system/multiselect';
import * as store from './store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { ButtonsModule } from '@anecdotes/design-system/buttons';

@NgModule({
  imports: [
    CommonModule,
    DataFilterModule,
    PerfectScrollbarModule,
    VirtualScrollerModule,
    MultiselectModule,
    StoreModule.forFeature(store.gridSharedStateFeatureKey, store.gridSharedReducers),
    TranslateModule.forChild(),
    SvgIconsModule,
    NgbTooltipModule,
    UtilsModule,
    ButtonsModule
  ],
  declarations: [GridComponent, GridSkeletonComponent, GridV2Component, GridPaginationButtonsComponent],
  providers: [GridViewBuilderService],
  exports: [GridComponent, GridSkeletonComponent, GridV2Component, GridPaginationButtonsComponent],
})
export class GridModule {
  static forRoot(): ModuleWithProviders<GridModule> {
    return {
      ngModule: GridModule,
      providers: [
        ...EffectsModule.forFeature(store.pagedGridSharedEffects).providers
      ]
    };
  }
}
